export default "__VITE_ASSET__CNU1vWZG__"